import { render, staticRenderFns } from "./B2CView.vue?vue&type=template&id=05bd9d6a&scoped=true"
import script from "./B2CView.vue?vue&type=script&lang=js"
export * from "./B2CView.vue?vue&type=script&lang=js"
import style0 from "./B2CView.vue?vue&type=style&index=0&id=05bd9d6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd9d6a",
  null
  
)

export default component.exports